/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateCompanyToBeDeletedInput = {|
  companyId: number,
  toBeDeleted?: ?boolean,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type updateCompanyToBeDeletedMutationVariables = {|
  input: UpdateCompanyToBeDeletedInput
|};
export type updateCompanyToBeDeletedMutationResponse = {|
  +UpdateCompanyToBeDeleted: ?{|
    +MissionControlCompanyToBeDeleted: ?{|
      +id: string,
      +toBeDeleted: ?boolean,
    |}
  |}
|};
export type updateCompanyToBeDeletedMutation = {|
  variables: updateCompanyToBeDeletedMutationVariables,
  response: updateCompanyToBeDeletedMutationResponse,
|};
*/


/*
mutation updateCompanyToBeDeletedMutation(
  $input: UpdateCompanyToBeDeletedInput!
) {
  UpdateCompanyToBeDeleted(input: $input) {
    MissionControlCompanyToBeDeleted {
      id
      toBeDeleted
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCompanyToBeDeletedInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCompanyToBeDeletedPayload",
    "kind": "LinkedField",
    "name": "UpdateCompanyToBeDeleted",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MissionControlCompanyToBeDeletedType",
        "kind": "LinkedField",
        "name": "MissionControlCompanyToBeDeleted",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "toBeDeleted",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateCompanyToBeDeletedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateCompanyToBeDeletedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateCompanyToBeDeletedMutation",
    "operationKind": "mutation",
    "text": "mutation updateCompanyToBeDeletedMutation(\n  $input: UpdateCompanyToBeDeletedInput!\n) {\n  UpdateCompanyToBeDeleted(input: $input) {\n    MissionControlCompanyToBeDeleted {\n      id\n      toBeDeleted\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '67bf4c5935dcd06dff4db90ef994060d';

module.exports = node;
